import {
    ClientActivityTracker, ClientUpdateHandlerRegistry, DeviceAccessor, FaviconProvider, WindowTitleProvider
} from "@mcleod/core";
import {
    PageHeaderProvider, SupportEmailProvider, TemporaryLicenseChangeHandler, UserLayoutProvider, WebMainPage
} from "@mcleod/common";
import { MainPageModule } from "@mcleod/common/src/mainpage/MainPageModule";
import { AppMainPage } from "@mcleod/mobile-common";
import { ProcessLogViewer } from "@mcleod/general";
import { LMEFaviconProvider } from "../general/src/LMEFaviconProvider";
import { LMEModelDataChangeFilterInitializer } from "../general/src/LMEModelDataChangeFilterInitializer";
import { LMEPageHeaderProvider } from "../general/src/LMEPageHeaderProvider";
import { LMESettingsInitializer } from "../general/src/settings/LMESettingsInitializer";
import { LMESupportEmailProvider } from "../general/src/LMESupportEmailProvider";
import { LMEUserLayoutProvider } from "../general/src/user/LMEUserLayoutProvider";
import { LMEWindowTitleProvider } from "../general/src/LMEWindowTitleProvider";

const rootElement = document.getElementById("root");
if (rootElement == null)
    throw new Error("Could not mount component because DOM element named root could not be found.");

provideAppSpecificConfiguration();

const modules: MainPageModule[] = [
    { path: "common", context: require["context"]("@mcleod/common/src", true) },
    { path: "lme/ar", context: require["context"]("@mcleod/ar/src", true) },
    { path: "lme/dispatch", context: require["context"]("@mcleod/dispatch/src", true) },
    { path: "lme/general", context: require["context"]("@mcleod/general/src", true) },
    { path: "lme/datafusion", context: require["context"]("@mcleod/datafusion/src", true) },
    { path: "lme/powerbroker", context: require["context"]("@mcleod/powerbroker/src", true) },
    { path: "lme/settlement", context: require["context"]("@mcleod/settlement/src", true) },
    { path: "lme/backoffice", context: require["context"]("@mcleod/backoffice/src", true) },
    { path: "lme/integrations", context: require["context"]("@mcleod/integrations/src", true) },
    { path: "lme/crm", context: require["context"]("@mcleod/crm/src", true) }
];

const mainPage = DeviceAccessor.isApp ?
    new AppMainPage({ modules: modules }) : new WebMainPage({
        modules: [
            { path: "designer", context: require["context"]("@mcleod/designer/src", true) },
            { path: "mobile-designer", context: require["context"]("@mcleod/mobile-designer/src", true) },
            { path: "component-demo", context: require["context"]("@mcleod/component-demo/src", true) },
            ...modules
        ]
    });

rootElement.appendChild(mainPage._element);

function provideAppSpecificConfiguration() {
    DeviceAccessor.initialize();
    ClientUpdateHandlerRegistry.get().register(new TemporaryLicenseChangeHandler());
    UserLayoutProvider.set(new LMEUserLayoutProvider());
    new LMESettingsInitializer().initialize();
    new LMEModelDataChangeFilterInitializer().initialize();
    WindowTitleProvider.set(new LMEWindowTitleProvider());
    FaviconProvider.set(new LMEFaviconProvider());
    PageHeaderProvider.set(new LMEPageHeaderProvider());
    SupportEmailProvider.set(new LMESupportEmailProvider());
    ClientActivityTracker.initializeGlobalListeners();
    ProcessLogViewer.registerProcessLogViewerHandler();
}
